import { useInvoiceDetailStore } from "../../store";
import { ProformaLink } from "./ProformaLink";

export const ProformaList = () => {
  const store = useInvoiceDetailStore();

  if (!store.invoice?.proformaInvoices.length) return null;

  return (
    <div>
      {store.invoice.proformaInvoices.map((i) => (
        <ProformaLink
          key={i.invoice.id}
          id={i.invoice.id}
          invoiceNo={i.invoice.invoice_no}
        />
      ))}
    </div>
  );
};
